export const dataOfItems = [
  {
    id: Math.random(),
    title: "وجبة عشاء",
    desc: `lorem ipsum dolor sit amet consectetur adipisicing elit.
    Quisquam, voluptatibus! lorem ipsum dolor sit amet consectetur adipisicing elit.
    Quisquam, voluptatibus!
    lorem ipsum dolor sit amet consectetur adipisicing elit.
    Quisquam, voluptatibus!
    lorem ipsum dolor sit amet consectetur adipisicing elit.
    Quisquam, voluptatibus!
    lorem ipsum dolor sit amet consectetur adipisicing elit.
    Quisquam, voluptatibus!
    lorem ipsum dolor sit amet consectetur adipisicing elit.
    Quisquam, voluptatibus!`,
    price: 20,
    img: "3.png",
    category: "dinner",
  },
  {
    id: Math.random(),
    title: "وجبة غداء",
    desc: `lorem ipsum dolor sit amet consectetur adipisicing elit.
    Quisquam, voluptatibus! lorem ipsum dolor sit amet consectetur adipisicing elit.
    Quisquam, voluptatibus!
    lorem ipsum dolor sit amet consectetur adipisicing elit.
    Quisquam, voluptatibus!
    lorem ipsum dolor sit amet consectetur adipisicing elit.
    Quisquam, voluptatibus!
    lorem ipsum dolor sit amet consectetur adipisicing elit.
    Quisquam, voluptatibus!
    lorem ipsum dolor sit amet consectetur adipisicing elit.
    Quisquam, voluptatibus!`,
    price: 40,
    img: "2.png",
    category: "lunch",
  },
  {
    id: Math.random(),
    title: "وجبة افطار",
    desc: `lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus! lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!`,
    price: 20,
    img: "4.png",
    category: "breakfast",
  },
  {
    id: Math.random(),
    title: "وجبة افطار",
    desc: `lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus! lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!`,
    price: 10,
    img: "5.png",
    category: "breakfast",
  },
  {
    id: Math.random(),
    title: "وجبة غداء",
    desc: `lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus! lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!`,
    price: 60,
    img: "3.png",
    category: "lunch",
  },
  {
    id: Math.random(),
    title: "وجبة عشاء",
    desc: `lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus! lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!`,
    price: 30,
    img: "1.png",
    category: "dinner",
  },
  {
    id: Math.random(),
    title: "وجبة خفيفة",
    desc: `lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus! lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!
     lorem ipsum dolor sit amet consectetur adipisicing elit.
     Quisquam, voluptatibus!`,
    price: 10,
    img: "3.png",
    category: "snacks",
  },
];
